import { Archive02Icon, User03Icon } from '@hugeicons/core-free-icons';
import { NavItem } from 'svnxii-ng-shared/components';

export const INSTALLMENT_NAV_ITEMS: NavItem[] = [
  // {
  //   title: 'Dashboard',
  //   icon: Archive02Icon,
  //   route: '/app/installment/dashboard',
  // },
  {
    title: 'Pending Sales Requests',
    icon: Archive02Icon,
    route: '/app/installment/pending-sales-request',
  },

  {
    title: 'Installments Accounts',
    icon: Archive02Icon,
    route: '/app/installment/accounts',
  },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/installment/notifications',
  },
];
